<script>
export default {
	name: "ColsRow",
	props: {
		row: {
			type: Object,
			default: () => {
			},
		},
	},
	render (createElement) {
		const validSlots = this.$slots.default.filter(slot => slot.tag);
		const cCol = validSlots.map((slot) => {
			return createElement("c-col", {
				attrs: Object.assign({
					cols: 12,
					md: "auto",
				}, this.$attrs, slot.data.attrs),
			}, [slot]);
		});
		return createElement("v-row", { attrs: Object.assign({ row: true }, this.row) }, [cCol]);
	},
};
</script>

<style scoped>

</style>
